var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-header"},[(_vm.isAuth('sys:menu:save'))?_c('vs-button',{attrs:{"color":"primary","type":"filled"},on:{"click":function($event){return _vm.$emit('add')}}},[_vm._v("新增")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }